import { pxToRem } from '@back-office/core';
import { Grid } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import React, { FC, PropsWithChildren } from 'react';
import { Submerchant } from '../../icons';
import { GcpBottomNavigation } from '../gcp-bottom-navigation';
import GcpBox from '../gcp-box';

const useStyles = makeStyles(
  () => ({
    submerchant: {
      width: pxToRem(160),
      height: 'auto',
    },
    container: {
      minHeight: '100vh',
    },
  }),
  { name: 'GcpPublicWrapper' }
);

interface GcpPublicWrapperProps {
  noLogo?: boolean;
}

const GcpPublicWrapper: FC<PropsWithChildren<GcpPublicWrapperProps>> = ({
  children,
  noLogo,
}) => {
  const classes = useStyles();

  return (
    <Grid
      container
      alignItems="center"
      className={classes.container}
      direction="column"
      justify="center"
      spacing={0}
    >
      <Grid container item md={6} xs={12}>
        <GcpBox isFullWidth hidden={noLogo} textAlign="center">
          <Submerchant className={classes.submerchant} />
        </GcpBox>
        {children}
      </Grid>
      <GcpBottomNavigation />
    </Grid>
  );
};

export default GcpPublicWrapper;
